export const enabledModules = (state) => state.modules;

export const getIsModuleEnabled = (state, getters) => (behaviourComponentKey) => {
    if(state.modules && state.modules.length) {
        return state.modules.filter((behaviourComponent) => behaviourComponent.key === behaviourComponentKey)?.[0]?.enabled;
    } else {
        return false;
    }
}